"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var TableHeader_1 = __importDefault(require("./TableHeader"));
var Prizes_1 = __importDefault(require("./Prizes"));
var Rules_1 = __importDefault(require("./Rules"));
var History_1 = __importDefault(require("./History"));
var FinishedRewards_1 = __importDefault(require("./FinishedRewards"));
var LotteryTableResultsAndPrizes = function (_a) {
    var id = _a.id, baseLottery = _a.baseLottery, isFinished = _a.isFinished;
    var _b = (0, react_1.useState)(0), activeTab = _b[0], setActiveTab = _b[1];
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement(TableHeader_1.default, { activeTab: activeTab, onClickHandler: setActiveTab }),
        activeTab === 0 &&
            (isFinished ? (react_1.default.createElement(FinishedRewards_1.default, { lotteryId: id })) : (react_1.default.createElement(Prizes_1.default, { rewards: baseLottery === null || baseLottery === void 0 ? void 0 : baseLottery.rewards }))),
        activeTab === 1 && react_1.default.createElement(Rules_1.default, { settings: baseLottery === null || baseLottery === void 0 ? void 0 : baseLottery.depositSettings }),
        activeTab === 2 && (react_1.default.createElement(History_1.default, { lotteryId: id, settings: baseLottery === null || baseLottery === void 0 ? void 0 : baseLottery.depositSettings }))));
};
exports.default = LotteryTableResultsAndPrizes;
